import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type FiltersTemperatureControl = Partial<{
  companyId: string[];
  productSku: string;
  productDescription: string;
  equipmentCode: string;
  productBatch: string;
  temperature: string[];
  eventDateFrom: string;
  eventDateTo: string;
}>;

export type PaginationControl = {
  page: number;
  limit: number;
  orderBy?: string;
  orderByDirection?: 'asc' | 'desc';
};

type State = {
  filters: FiltersTemperatureControl;
  paginationControl: PaginationControl;
};

type Actions = {
  updateFilters: (filters: FiltersTemperatureControl) => void;
  updatePaginationControl: (
    paginationControl: Partial<PaginationControl>
  ) => void;
  clearState: () => void;
};

type Options = {
  persisted?: boolean;
};

const getInitialState = (): State => ({
  filters: {},
  paginationControl: {
    page: 1,
    limit: 10,
  },
});

const PERSISTENCE_OPTIONS = {
  name: 'temperature-control-search-params',
  version: 1,
};

const store = create<State & Actions>((set) => ({
  ...getInitialState(),
  updateFilters: (filters) => set({ filters }),
  updatePaginationControl: (paginationControl) => {
    return set((state) => ({
      paginationControl: {
        ...state.paginationControl,
        ...paginationControl,
      },
    }));
  },
  clearState: () => set(getInitialState()),
}));

const persistStore = create(
  persist<State & Actions>(
    (set) => ({
      ...getInitialState(),
      updateFilters: (filters) => set({ filters }),
      updatePaginationControl: (paginationControl) => {
        return set((state) => ({
          paginationControl: {
            ...state.paginationControl,
            ...paginationControl,
          },
        }));
      },
      clearState: () => set(getInitialState()),
    }),
    PERSISTENCE_OPTIONS
  )
);

export const useTemperatureControlSearchParams = (options?: Options) => {
  return options?.persisted ? persistStore() : store();
};
